import React from "react";

export default function ReviewHead({ title, subtitle }) {
  return (
    <header className="w-full pb-5 border-b border-gray-200">
      <h2 className="text-lg font-medium text-primary-800 mb-1">
        {title || ""}
      </h2>
      <p className="text-sm text-primary-500 font-normal">{subtitle || ""}</p>
    </header>
  );
}
